import { render, staticRenderFns } from "./productsPage.vue?vue&type=template&id=4c31cea1&scoped=true&"
import script from "./productsPage.vue?vue&type=script&lang=js&"
export * from "./productsPage.vue?vue&type=script&lang=js&"
import style0 from "./productsPage.vue?vue&type=style&index=0&id=4c31cea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c31cea1",
  null
  
)

export default component.exports